// CUSTOM: Shipping protection toggle
document.addEventListener('change', function(e) {
  if (!e.target || e.target.id !== 'protection-toggle') return;

  const checked = e.target.checked;
  const variantId = 53595440644424;
  const endpoint = checked ? '/cart/add.js' : '/cart/change.js';
  const body = checked
    ? JSON.stringify({ id: variantId, quantity: 1 })
    : JSON.stringify({ id: variantId, quantity: 0 });

  fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body
  })
  .then(res => res.json())
  .then(() => {
    // Fetch full cart data to pass with the event
    return fetch('/cart.js').then(res => res.json());
  })
  .then(cartData => {
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('cart:update', { 
        bubbles: true,
        detail: { data: cartData }
      }));
    }, 300);
  })
  .catch(err => console.error('Protection error:', err));
});

// CUSTOM: Product page viewers popup
(function() {
  if (!window.location.pathname.includes('/products/')) return;
  if (sessionStorage.getItem('viewers-closed')) return;

  function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const count = randomBetween(4, 28);

  const popup = document.createElement('div');
  popup.id = 'viewers-popup';
  popup.innerHTML = `
    <button id="viewers-close">×</button>
    <div id="viewers-inner">
      <span class="viewers-dot"></span>
      <p class="viewers-text"><strong>${count} people</strong> are also viewing this item</p>
    </div>
  `;
  document.body.appendChild(popup);

  document.getElementById('viewers-close').addEventListener('click', () => {
    sessionStorage.setItem('viewers-closed', 'true');
    popup.remove();
  });
})();
